var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm6 9.867l-5.688 3.678-.086.045a.579.579 0 01-.465-.005l-.073-.04L6 9.867V14.8A1.2 1.2 0 007.2 16h9.6a1.2 1.2 0 001.2-1.2V9.867zM16.8 8H7.2a1.2 1.2 0 00-1.064.644L12 12.434l5.864-3.79A1.2 1.2 0 0016.8 8z",
    fill: "#223260"
  })));
}
export default SvgMail;